import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  const formatViews = (num: number): string => {
    if (num >= 10000) {
      return (num / 10000).toFixed(1) + '万';
    }
    return num.toString();
  };

  return (
    <Link
      to={`/article/${video.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
    >
      <div className="relative overflow-hidden aspect-video">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 密桃视频高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        <span className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
          {video.duration}
        </span>
        <div className="absolute top-2 left-2 flex gap-1.5">
          <span className="bg-accent-500 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
            {video.source}
          </span>
          {video.featured && (
            <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
              精选
            </span>
          )}
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-accent-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center justify-between mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line w-3 h-3 flex items-center justify-center" />
            {formatViews(video.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center" />
            {video.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}